import {
  EXPORT_FILE_REQUEST,
  EXPORT_FILE_SUCCESS,
  EXPORT_FILE_ERROR,
  SEND_REPORT_REQUEST,
  SEND_REPORT_ERROR,
  SEND_REPORT_SUCCESS,
  SET_DELIVERED_REQUEST,
  SET_DELIVERED_ERROR,
  SET_DELIVERED_SUCCESS
} from './constants';
import { BASE_URL, UUID } from '../../../middleware/api';
import {
  GET_XLSX_FILE,
  GET_CSV_FILE,
  SEND_IMAGES_REPORT
} from '../../../services/ApiEndpointsConstants';

import * as FileSaver from 'file-saver';

export const setDeliveredStatus = (domainData, domainId) => {
  return async (dispatch) => {
    const token = localStorage.getItem(UUID) || null;
    const endPoint = `/assessment_domain/${domainId}/set_delivered`;

    dispatch({ type: SET_DELIVERED_REQUEST });

    let delivered = null;

    const requestOptions = {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify(domainData)
    };

    try {
      const response = await fetch(`${BASE_URL}${endPoint}`, requestOptions);
      const result = await response.json();
      delivered = result;
    } catch (error) {
      console.error('Error fetching photos data from the server', error);
    }

    if (!delivered) {
      dispatch({ type: SET_DELIVERED_ERROR });
    }

    return dispatch({
      type: SET_DELIVERED_SUCCESS
    });
  };
};

export const sendReportForImages = (id) => {
  return async (dispatch) => {
    const token = localStorage.getItem(UUID) || null;
    const requestOptions = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      }
    };

    dispatch({ type: SEND_REPORT_REQUEST });

    let reportStatus = null;

    try {
      const response = await fetch(
        `${BASE_URL}${SEND_IMAGES_REPORT}/${id}`,
        requestOptions
      );
      const result = await response.json();
      reportStatus = result;
    } catch (error) {
      console.error('Error fetching photos data from the server', error);
    }

    if (!reportStatus) {
      dispatch({ type: SEND_REPORT_ERROR });
    }

    return dispatch({
      type: SEND_REPORT_SUCCESS,
      reportStatus
    });
  };
};

export const setDownLoadFileRequest = (
  fileName,
  xls,
  domainData,
  domainId,
  country
) => {
  return async (dispatch) => {
    const token = localStorage.getItem(UUID) || null;
    const checkEndpoint =
      xls === 'xls' || xls === 'legal' ? GET_XLSX_FILE : GET_CSV_FILE;
    const typeForBlob =
      xls === 'xls' || xls === 'legal'
        ? 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        : 'text/csv';
    const fileEndpoint = xls === 'xls' || xls === 'legal' ? 'xlsx' : 'csv';

    if (xls === 'legal') {
      if (domainData.otherCountries === country) {
        domainData.priorityCountry = null;
      } else if (domainData.priorityCountry === country) {
        domainData.otherCountries = null;
      }
    }

    const requestOptions = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      }
    };

    dispatch({ type: EXPORT_FILE_REQUEST });

    let filesData = null;

    try {
      const response = await fetch(
        `${BASE_URL}${checkEndpoint}/${domainId}`,
        requestOptions
      );
      const result = await response.arrayBuffer();
      filesData = result;
    } catch (error) {
      console.error('Error fetching files data from the server', error);
    }

    let blob = new Blob([filesData], { type: typeForBlob });
    FileSaver.saveAs(blob, `${fileName}.${fileEndpoint}`);

    if (!filesData) {
      return dispatch({ type: EXPORT_FILE_ERROR });
    }

    return dispatch({
      type: EXPORT_FILE_SUCCESS,
      filesData
    });
  };
};
